import { lazy, memo } from 'react';
import { Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';

import { Breadcrumb } from 'primary-components';

import { allBreadcrumbs } from 'resources/constants/allBreadcrumbs';
import { routing } from 'routing';

import { PublicSideBar } from 'primary/SideBar';

import ErrorBoundaryLocal from '../ErrorBoundary';

import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';

const Insight = lazy(() => import('components/modules/Insight'))

const PublicRouting = () => {
  const navigate = useNavigate()

  return (
    <Routes>
      <Route
          element={(
            <div className="root">
              <PublicSideBar/>
              <div className="content"> 
                <Breadcrumb 
                    items={allBreadcrumbs}
                    navigate={navigate}
                />
                <Outlet/>
              </div>
            </div>
          )}
          ErrorBoundary={ErrorBoundaryLocal}
          path="/Public"
      >
          <Route 
              element={<Insight/>}
              ErrorBoundary={ErrorBoundaryLocal}
              path={`${routing.insight.name}/*`}
          />
          <Route 
              element={(
                <Navigate to={DashboardLinkFactory.insight.publicRoot({ baseUrl: "" })}/>
              )}
              ErrorBoundary={ErrorBoundaryLocal}
              path="*"
          />
      </Route>
    </Routes>
  )
}

export default memo(PublicRouting);
